import { ColorPickerField } from '../../components/ColorPickerField';
import RankPortalList from './RankPortalList';

const rankPortalListPlugin: any = {
  Renderer: ({ data }: any) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className="rank-portal-list-outer"
    >
      <RankPortalList
        title={data?.title}
        listItems={data.listItems}
        backgroundColor={data?.backgroundColor}
        height={data?.height}
      />
    </div>
  ),
  id: 'rankPortalList',
  title: 'Checklist Bullets',
  // description: 'reankPortal with configurable elements',
  version: 1,
  controls: {
    type: 'autoform',
    columnCount: 1,
    schema: {
      properties: {
        title: {
          type: 'string',
          default: 'Enter title',
        },
        height: {
          type: 'string',
          default: 'auto',
        },
        backgroundColor: {
          type: 'string',
          default: 'rgba(204,204,204,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Background Color: ',
          },
        },
        listItems: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              listItemText: {
                type: 'string',
                default: 'Enter text',
              },
            },
          },
        },
      },
      required: ['listItems', 'title'],
    },
  },
};
export default rankPortalListPlugin;
